module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/ribbon/tags/tags.component.scss
// module id = ./src/app/features/ribbon/tags/tags.component.scss
// module chunks = main